import { IAuthorizationRequirement } from '../authorizationrequirement';

export class DenyAnonymousRequirement implements IAuthorizationRequirement {
  name: string;

  constructor() {
    this.name = `DenyAnonymousRequirement`;
  }
}
